import { LoginUser } from '@/domain/LoginUser'
import axios from 'axios'

/**
 * ユーザログインサービス
 */
export default class LoginService {
    /** インスタンス */
    private static _instance: LoginService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new LoginService();
        }
        return this._instance;
    }

    /**
     * ログイン
     * @param userId 
     * @param password 
     */
    public async login(userId: string, password: string) {
        const params = new URLSearchParams()
        params.append("userId", userId)
        params.append("password", password)
        return await axios.post("/login", params)
            .then((results) => {
                if (results.status === 200) {
                    return new LoginUser(results.data)
                } else {
                    // 発生しない
                    return "ユーザの認証に失敗しました"
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        return "ユーザ名またはパスワードが違います"
                    } else {
                        // Webサーバのみ稼働(Bad Gateway: 502)
                        return "ログイン認証エラーが発生しました"
                    }
                } else {
                    // 通信エラー
                    return "サーバ通信エラーが発生しました"
                }
            })
    }

    /**
     * ログアウト
     */
    public async logout() {
        await axios.get("/logout")
    }
}
